import React, { useState, useEffect, useContext } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import EventKit from "../data/EventKit";
import MessageList from "./Message/MessageList";
import { UserContext } from "../contexts/UserContext";
import { EventContext } from "../contexts/EventContext";
import prefixCSS from "../util/prefixCSS";
import CustomCSSRenderer from "./CustomCSSRenderer";

export default function LayoutPrivate({ children, hasAnnouncement }) {
  const [eventData, setEventData] = useState(null);
  const { me, setMe } = useContext(UserContext);
  const { globalEventData, setGlobalEventData } = useContext(EventContext);

  const eventKit = new EventKit();
  const router = useRouter();
  const { event } = router.query;

  useEffect(() => {
    if (event) {
      if (globalEventData) {
        setEventData(globalEventData);
      } else {
        eventKit
          .getEventDetail(event)
          .then((data) => {
            setEventData(data);
            setGlobalEventData(data);
          })
          .catch((errors) => console.log(errors));
      }

      if (!me) {
        eventKit
          .getEventUserMe(event)
          .then((data) => {
            setMe(data);
          })
          .catch((errors) => {
            console.log(errors);
          });
      }
    }
  }, [event]);

  useEffect(() => {
    if (eventData && me && !eventKit.shouldRender(eventData, me)) {
      router.push(`/${event}/idle`);
    }
  }, [eventData, me]);

  return (
    <>
      <Head>
        {/* <style>{eventData && eventData.customCss && prefixCSS(eventData.customCss, "#page")}</style> */}
      </Head>

      <CustomCSSRenderer eventCSS={eventData?.customCss} />

      {hasAnnouncement === false ? false : true && <MessageList />}
      {eventKit.shouldRender(eventData, me) && <>{children}</>}
      <div
        dangerouslySetInnerHTML={{
          __html: eventData && eventData.customHtml,
        }}
      ></div>
    </>
  );
}
